define([
    "csi/access/_base",
    "csi/access/access",
    "csi/access/full",
    "csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {

	var sourcingLibAdminRoles = ['Sourcing Library Administrator'];
	var supplierAdminRoles = ['Supplier Administrator'];
	var supplierEditRoles = supplierAdminRoles.concat(['Supplier Editor']);
	var countryAdminRoles = sourcingLibAdminRoles.concat(['Product Specification Library Administrator','Business Plan Library Administrator']);

	csiAccess.addViewRoles({
		"LibSourcing":{
		    "Countries":{
		        "NewCountry":access(full(countryAdminRoles)),
		        "Copy":access(full(countryAdminRoles))
		    },
			"SourcingCapabilities":{
				"Copy":access(full(sourcingLibAdminRoles)),
				"NewSourcingCapability":access(full(sourcingLibAdminRoles))
			},
			"Suppliers":{
				"NewSupplier":access(full(supplierAdminRoles))
			},
			"ShippingPorts":{
				"Copy":access( full(supplierEditRoles), full(sourcingLibAdminRoles)),
				"NewShippingPort":access( full(supplierEditRoles), full(sourcingLibAdminRoles))
			}
		},
		"Supplier":{
			"Suppliers":{
				"NewSupplier":access(full(supplierAdminRoles))
			}
		}
	});
});